/* eslint-disable */
import clsx from "clsx";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { CloseIcon } from "../../../../assets/Icons";
import {
  offlineA2FormUpload,
  offlineBeneficiaryId,
  offlineInstructSheet,
  offlineLoanLetter,
  offlineOffer,
  offlinePaymentConf,
  offlineRelationShipProof,
  offlineSelfDeclaration,
  offlineStudentPassport,
} from "../../../../services/offline";
import { offlineSBM } from "../../../../store";
import Lottie from "react-lottie";
import * as animationData from "../../../../assets/lottieAnimationsData/scanDocuments.json";
import { i20Upload } from "../../../../services/purposeCode";
import { getPurposeCode } from "../../../../utils";

export const OfflineSBMDocuments = () => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const [offlineSbmData, setOfflineSBMData] = useRecoilState(offlineSBM);
  const [utrNo, setUtrNo] = useState<string>("");
  const [a2FormError, setA2FormError] = React.useState<string>("");
  const [beneIdError, setBenIdError] = React.useState<string>("");
  const [uniOfferError, setUniOfferError] = React.useState<string>("");
  const [loanSanctionError, setLoanSanctionError] = React.useState<string>("");
  const [selfDeclaError, setSelfDeclaError] = React.useState<string>("");
  const [relationProofError, setRelationProofError] = React.useState<string>("");
  const [instSheetError, setInstSheetError] = React.useState<string>("");
  const [i20Error, setI20Error] = React.useState<string>("");
  const [paymentConfirmError, setPaymentConfirmError] = React.useState<string>("");
  const [isDocScan, setIsDocScan] = React.useState<boolean>(false);
  const navigate = useNavigate();

  React.useEffect(() => {
    setOfflineSBMData({
      ...offlineSbmData,
      transactionLeadIds: [],
    });
  }, [navigate]);

  const defaultAnimationOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
  };

  const handleNextClicked = () => {
    setOfflineSBMData({
      ...offlineSbmData,
      utrNo: utrNo,
    });
    navigate("/1/review");
  };

  const uploadOfflineA2Form = async (e: any) => {
    const fileData = e.target.files[0];
    setIsDocScan(true);
    let data = new FormData();
    data.append("file", fileData);
    setA2FormError("");
    await offlineA2FormUpload(currentUser, data)
      .then((response) => {
        setIsDocScan(false);
        if (response?.data?.success === true) {
          setOfflineSBMData({
            ...offlineSbmData,
            transactionLeadIds: {
              ...offlineSbmData.transactionLeadIds,
              offlineA2Form: response.data.leadDocId,
            },
          });
        }
      })
      .catch((error) => {
        setIsDocScan(false);
        setA2FormError(error?.response?.data?.error?.type);
      });
  };

  const uploadRelationProof = async (e: any) => {
    const fileData = e.target.files[0];
    setIsDocScan(true);
    let data = new FormData();
    data.append("file", fileData);
    await offlineRelationShipProof(currentUser, data)
      .then((response) => {
        setIsDocScan(false);
        setRelationProofError("");
        if (response?.data?.success === true) {
          setOfflineSBMData({
            ...offlineSbmData,
            transactionLeadIds: {
              ...offlineSbmData.transactionLeadIds,
              relationProof: response.data.leadDocId,
            },
          });
        }
      })
      .catch((error) => {
        setIsDocScan(false);
        setRelationProofError(error?.response?.data?.error?.type);
      });
  };

  const uploadOfflineSelfDeclaration = async (e: any) => {
    const fileData = e.target.files[0];
    setIsDocScan(true);
    let data = new FormData();
    data.append("file", fileData);
    await offlineSelfDeclaration(currentUser, data)
      .then((response) => {
        setIsDocScan(false);
        setSelfDeclaError("");
        if (response?.data?.success === true) {
          setOfflineSBMData({
            ...offlineSbmData,
            transactionLeadIds: {
              ...offlineSbmData.transactionLeadIds,
              selfDeclaration: response.data.leadDocId,
            },
          });
        }
      })
      .catch((error) => {
        setIsDocScan(false);
        setSelfDeclaError(error?.response?.data?.error?.type);
      });
  };

  const uploadOfflineBeneId = async (e: any) => {
    const fileData = e.target.files[0];
    setIsDocScan(true);
    let data = new FormData();
    data.append("file", fileData);
    setBenIdError("");
    await offlineBeneficiaryId(currentUser, data)
      .then((response) => {
        setIsDocScan(false);
        if (response.data.success === true) {
          setOfflineSBMData({
            ...offlineSbmData,
            transactionLeadIds: {
              ...offlineSbmData?.transactionLeadIds,
              offlineBeneficiaryId: response.data.leadDocId,
            },
          });
        }
      })
      .catch((error) => {
        setIsDocScan(false);
        setBenIdError(error?.response?.data?.error?.type);
      });
  };

  const offlineOfferLetter = async (e: any) => {
    const fileData = e.target.files[0];
    // eslint-disable-next-line prefer-const
    setIsDocScan(true);
    let data = new FormData();
    data.append("file", fileData);
    await offlineOffer(currentUser, data)
      .then((response) => {
        setIsDocScan(false);
        setUniOfferError("");
        if (response.data.success === true) {
          setOfflineSBMData({
            ...offlineSbmData,
            transactionLeadIds: {
              ...offlineSbmData.transactionLeadIds,
              offlineUniOfferLetter: response.data.leadDocId,
            },
          });
        }
      })
      .catch((error) => {
        setIsDocScan(false);
        setUniOfferError(error?.response?.data?.error?.type);
      });
  };

  const uploadOfflineLoanLetter = async (e: any) => {
    setIsDocScan(true);
    const fileData = e.target.files[0];
    // eslint-disable-next-line prefer-const
    let data = new FormData();
    data.append("file", fileData);
    await offlineLoanLetter(currentUser, data)
      .then((response) => {
        setIsDocScan(false);
        setLoanSanctionError("");
        if (response.data.success === true) {
          setOfflineSBMData({
            ...offlineSbmData,
            transactionLeadIds: {
              ...offlineSbmData.transactionLeadIds,
              offlineLoanLetter: response.data.leadDocId,
            },
          });
        }
      })
      .catch((error) => {
        setIsDocScan(false);
        setLoanSanctionError(error?.response?.data?.error?.type);
      });
  };

  const offlineInstructionSheet = async (e: any) => {
    setIsDocScan(true);
    const fileData = e.target.files[0];
    // eslint-disable-next-line prefer-const
    let data = new FormData();
    data.append("file", fileData);
    await offlineInstructSheet(currentUser, data)
      .then((response) => {
        setIsDocScan(false);
        setInstSheetError("");
        if (response.data.success === true) {
          setOfflineSBMData({
            ...offlineSbmData,
            transactionLeadIds: {
              ...offlineSbmData.transactionLeadIds,
              offlineInstructionSheet: response.data.leadDocId,
            },
          });
        }
      })
      .catch((error) => {
        setIsDocScan(false);
        setInstSheetError(error?.response?.data?.error?.type);
      });
  };

  const handleI20Upload = async (e: any) => {
    setIsDocScan(true);
    const fileData = e.target.files[0];
    // eslint-disable-next-line prefer-const
    let data = new FormData();
    let code = await getPurposeCode(offlineSbmData?.transaction_purpose);
    data.append("file", fileData);
    await i20Upload(data, `doc?docType=i-20&purpose=${code}`)
      .then((response) => {
        setIsDocScan(false);
        setI20Error("");
        if (response.data.success === true) {
          setOfflineSBMData({
            ...offlineSbmData,
            transactionLeadIds: {
              ...offlineSbmData.transactionLeadIds,
              i20Doc: response.data.leadDocId,
            },
          });
        }
      })
      .catch((error) => {
        setIsDocScan(false);
        setI20Error(error?.response?.data?.error?.type);
      });
  };

  const uploadPaymentConfirmation = async (e: any) => {
    setIsDocScan(true);
    const fileData = e.target.files[0];
    // eslint-disable-next-line prefer-const
    let data = new FormData();
    data.append("file", fileData);
    await offlinePaymentConf(currentUser, data)
      .then((response) => {
        setIsDocScan(false);
        setPaymentConfirmError("");
        if (response.data.success === true) {
          setOfflineSBMData({
            ...offlineSbmData,
            transactionLeadIds: {
              ...offlineSbmData.transactionLeadIds,
              offlinePaymentConfirmation: response.data.leadDocId,
            },
          });
        }
      })
      .catch((error) => {
        setIsDocScan(false);
        setPaymentConfirmError(error?.response?.data?.error?.type);
      });
  };

  return (
    <div>
      <div id="wrapper" className="flex flex-col items-center">
        <div
          id="topBanner"
          onClick={() => navigate("/home")}
          className="p-6 ml-[1430px] mt-2 hover:scale-150 cursor-pointer transition-all"
        >
          <CloseIcon />
        </div>
        <div id="body" className="flex w-full px-5 mt-10">
          <div className="flex flex-col w-1/2 px-5 mr-2 border-r-2">
            <span className="font-bold text-[35px]">Supporting Document</span>
            <div id="docs" className="flex flex-col mt-10 space-y-7">
              <div id="passport" className="flex items-center justify-between w-full">
                <div className="flex flex-col">
                  <div className="flex items-center space-x-10">
                    <span className="font-semibold font-ssp text-[22px]">
                      Bene ID (Any Valid ID Proof)
                      <span className="font-bold text-red-600 text-[22px]">*</span>
                    </span>
                  </div>
                  {beneIdError ? (
                    <span className="absolute mt-8 text-red-600">{beneIdError}</span>
                  ) : null}
                </div>
                <input
                  accept="/*"
                  type="file"
                  className={clsx(
                    offlineSbmData?.transactionLeadIds?.offlineStudentPassport === undefined
                      ? "text-black"
                      : "text-primary text-[12px] ",
                    "w-[200px]",
                  )}
                  onChange={(e: any) => uploadOfflineBeneId(e)}
                />
              </div>
              <div id="a2" className="flex items-center justify-between w-full">
                <div className="flex flex-col">
                  <div className="flex items-center space-x-1">
                    <span className="font-semibold font-ssp text-[22px]">A2</span>
                  </div>
                  {a2FormError ? (
                    <span className="absolute mt-8 text-red-600">{a2FormError}</span>
                  ) : null}
                </div>
                <input
                  accept="/*"
                  type="file"
                  className={clsx(
                    offlineSbmData?.transactionLeadIds?.offlineA2Form === undefined
                      ? "text-black"
                      : "text-primary text-[12px]",
                    "w-[200px]",
                  )}
                  onChange={(e: any) => uploadOfflineA2Form(e)}
                />
              </div>
              <div id="univOfferLe" className="flex items-center justify-between w-full">
                <div className="flex flex-col">
                  <div className="flex items-center space-x-10">
                    <span className="font-semibold font-ssp text-[22px]">
                      University Offer Letter{" "}
                      <span className="text-primary text-[12px]">(if any)</span>
                    </span>
                  </div>
                  {uniOfferError ? (
                    <span className="absolute mt-8 text-red-600">{uniOfferError}</span>
                  ) : null}
                </div>
                <input
                  accept="/*"
                  type="file"
                  className={clsx(
                    offlineSbmData?.transactionLeadIds?.offlineUniOfferLetter === undefined
                      ? "text-black"
                      : "text-primary text-[12px]",
                    "w-[200px]",
                  )}
                  onChange={(e: any) => offlineOfferLetter(e)}
                />
              </div>
              <div id="instSheet" className="flex items-center justify-between w-full">
                <div className="flex flex-col">
                  <div className="flex items-center space-x-10">
                    <span className="font-semibold font-ssp text-[22px]">
                      Loan Disbursement Letter{" "}
                      <span className="text-primary text-[12px]">(if any)</span>
                    </span>
                  </div>
                  {loanSanctionError ? (
                    <span className="absolute mt-8 text-red-600">{loanSanctionError}</span>
                  ) : null}
                </div>
                <input
                  accept="/*"
                  type="file"
                  className={clsx(
                    offlineSbmData?.transactionLeadIds?.offlineLoanLetter === undefined
                      ? "text-black"
                      : "text-primary text-[12px]",
                    "w-[200px]",
                  )}
                  onChange={(e: any) => uploadOfflineLoanLetter(e)}
                />
              </div>

              <div id="declaration" className="flex items-center justify-between w-full">
                <div className="flex flex-col">
                  <div className="flex items-center space-x-10">
                    <span className="font-semibold font-ssp text-[22px]">
                      Self Declaration <span className="text-primary text-[12px]">(if any)</span>
                    </span>
                  </div>
                  {selfDeclaError ? (
                    <span className="absolute mt-8 text-red-600">{selfDeclaError}</span>
                  ) : null}
                </div>
                <input
                  accept="/*"
                  type="file"
                  className={clsx(
                    offlineSbmData?.transactionLeadIds?.selfDeclaration === undefined
                      ? "text-black"
                      : "text-primary text-[12px]",
                    "w-[200px]",
                  )}
                  onChange={(e: any) => uploadOfflineSelfDeclaration(e)}
                />
              </div>
              <div id="relProof" className="flex items-center justify-between w-full">
                <div className="flex flex-col">
                  <div className="flex items-center space-x-10">
                    <span className="font-semibold font-ssp text-[22px]">
                      Relationship Proof <span className="text-primary text-[12px]">(if any)</span>
                    </span>
                  </div>
                  {relationProofError ? (
                    <span className="absolute mt-8 text-red-600">{relationProofError}</span>
                  ) : null}
                </div>
                <input
                  accept="/*"
                  type="file"
                  className={clsx(
                    offlineSbmData?.transactionLeadIds?.relationProof === undefined
                      ? "text-black"
                      : "text-primary text-[12px]",
                    "w-[200px]",
                  )}
                  onChange={(e: any) => uploadRelationProof(e)}
                />
              </div>
              <div id="instSheet" className="flex items-center justify-between w-full">
                <div className="flex flex-col">
                  <div className="flex items-center space-x-10">
                    <span className="font-semibold font-ssp text-[22px]">
                      Instruction Sheet <span className="text-primary text-[12px]">(if any)</span>
                    </span>
                  </div>
                  {instSheetError ? (
                    <span className="absolute mt-8 text-red-600">{instSheetError}</span>
                  ) : null}
                </div>
                <input
                  accept="/*"
                  type="file"
                  className={clsx(
                    offlineSbmData?.transactionLeadIds?.i20Doc === undefined
                      ? "text-black"
                      : "text-primary text-[12px]",
                    "w-[200px]",
                  )}
                  onChange={(e: any) => offlineInstructionSheet(e)}
                />
              </div>
              {offlineSbmData?.purposeCode === "S0305" && (
                <div id="instSheet" className="flex items-center justify-between w-full">
                  <div className="flex flex-col">
                    <div className="flex items-center space-x-10">
                      <span className="font-semibold font-ssp text-[22px]">
                        I20 Document <span className="text-primary text-[12px]">(if any)</span>
                      </span>
                    </div>
                    {i20Error ? (
                      <span className="absolute mt-8 text-red-600">{i20Error}</span>
                    ) : null}
                  </div>
                  <input
                    accept="/*"
                    type="file"
                    className={clsx(
                      offlineSbmData?.transactionLeadIds?.offlineInstructionSheet === undefined
                        ? "text-black"
                        : "text-primary text-[12px]",
                      "w-[200px]",
                    )}
                    onChange={(e: any) => handleI20Upload(e)}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="flex flex-col w-1/2 px-5">
            <span className="font-bold text-[35px]">Payment Details</span>
            <div>
              <div
                id="otherDocBox"
                className="flex flex-col items-center justify-between px-5 py-4 mt-12 space-y-8 border border-gray-400 rounded-xl"
              >
                <div id="payconfirm" className="flex items-center justify-between w-full">
                  <div className="flex flex-col">
                    <div className="flex items-center space-x-10">
                      <span className="font-semibold font-ssp text-[22px]">
                        Payment Confirmation
                      </span>
                    </div>
                    {paymentConfirmError ? (
                      <span className="absolute mt-8 text-red-600">{paymentConfirmError}</span>
                    ) : null}
                  </div>
                  <input
                    accept="/*"
                    type="file"
                    className={clsx(
                      offlineSbmData?.transactionLeadIds?.offlinePaymentConfirmation === undefined
                        ? "text-black"
                        : "text-primary text-[12px]",
                      "w-[200px]",
                    )}
                    onChange={(e: any) => uploadPaymentConfirmation(e)}
                  />
                </div>
                <div className="flex items-center justify-between w-full">
                  <span className="font-semibold font-ssp text-[22px]">Payment UTR No.</span>
                  <input
                    placeholder="Enter UTR No."
                    className="px-10 py-2 bg-blue-100 border border-gray-500 rounded-md"
                    onChange={(e: any) => setUtrNo(e.target.value)}
                    autoComplete="off"
                    pattern="[a-zA-Z0-9 ]{1,}"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-10">
          <button
            disabled={
              !offlineSbmData?.transactionLeadIds?.offlineBeneficiaryId ||
              a2FormError !== "" ||
              beneIdError !== ""
            }
            onClick={handleNextClicked}
            className={clsx(
              !offlineSbmData?.transactionLeadIds?.offlineBeneficiaryId ||
                a2FormError !== "" ||
                beneIdError !== ""
                ? "px-10 py-4 mt-20 font-bold text-white transition-all rounded-lg shadow-xl bg-gray-700"
                : "px-10 py-4 mt-20 font-bold text-white transition-all rounded-lg shadow-xl hover:bg-white hover:text-primary bg-primary hover:border-2 hover:border-primary",
            )}
          >
            Next
          </button>
        </div>
      </div>
      {isDocScan && (
        <div className="fixed z-50 flex-1 -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2">
          <Lottie options={defaultAnimationOptions} height={400} width={400} ariaRole="animation" />
        </div>
      )}
    </div>
  );
};
